// eslint-disable-next-line
import {
  Box,
  Button,
  Flex,
  Icon,
  IconButton,
  Input,
  InputGroup,
  InputLeftElement,
} from '@chakra-ui/react';
import { useEffect } from 'react';
import DataTable from 'react-data-table-component';
import SidebarWithHeader from '../../../../components/Admin/SidebarWithHeader';
import Loader from '../../../../components/Loader';
import PemateriContext, {
  usePemateriContext,
} from '../../../../controller/admin/data_master/pemateri';
import { FaSearch } from 'react-icons/fa';
import { AiFillPlusCircle } from 'react-icons/ai';
import ModalFormPemateri from '../../../../components/Admin/master/pemateri/ModalForm';
import { BsTrashFill } from 'react-icons/bs';
import ModalDeletePemateri from '../../../../components/Admin/master/pemateri/ModalDelete';
import { BiEdit } from 'react-icons/bi';
import { useRole } from '../../../../../hooks/useRole';

const Pemateri = () => {
  const { setPemateriState, getDataPemateri } = usePemateriContext().dispatch;
  const {
    btnFilterSelected,
    page,
    perPage,
    listData,
    keyword,
    isLoading,
    totalPage,
  } = usePemateriContext().state;
  const { canMutate } = useRole();

  const columns = [
    {
      name: 'No.',
      selector: (row, index) => (page - 1) * perPage + (index + 1),
      grow: 0,
    },
    {
      name: 'Nama',
      selector: (row) => row.nama,
      sortable: true,
      width: '200px',
      wrap: true,
    },
    {
      name: 'NIP',
      selector: (row) => row.nip ?? '-',
      sortable: true,
    },
    {
      name: 'NIK',
      selector: (row) => row.nik ?? '-',
      sortable: true,
    },
    {
      name: 'Jabatan',
      selector: (row) => row.jabatan ?? '-',
      sortable: true,
    },
    {
      name: 'Instansi',
      selector: (row) => row.instansi ?? '-',
      width: '100px',
    },
    {
      name: 'Jenis Pemateri',
      selector: (row) => (row.jenis === 'NON_ASN' ? 'NON ASN' : row.jenis),
      sortable: true,
    },
    ...(canMutate
      ? [
          {
            name: 'Action',
            selector: (row) => {
              return (
                <Box display="flex" alignItems="center">
                  {/* Edit Button */}
                  <IconButton
                    ml={2}
                    bg="green.100"
                    aria-label="Edit User"
                    icon={<Icon as={BiEdit} color="green.600" boxSize={5} />}
                    h="30px"
                    minW="36px"
                    _hover={{ bg: 'green.200' }}
                    _active={{ bg: 'green.300' }}
                    onClick={() => [
                      setPemateriState('dataEdit', row),
                      setPemateriState('isEdit', true),
                      setPemateriState('isOpenModalPemateri', true),
                    ]}
                  />
                  <IconButton
                    ml={2}
                    bg="red.100"
                    aria-label="Log User Activity"
                    icon={<Icon as={BsTrashFill} color="red.400" boxSize={5} />}
                    h="30px"
                    minW="36px"
                    _hover={{ bg: 'red.200' }}
                    _active={{ bg: 'red.300' }}
                    onClick={() => {
                      setPemateriState('idDelete', row.id);
                      setPemateriState('isOpenModalDeletePemateri', true);
                    }}
                  />
                </Box>
              );
            },
            sortable: true,
          },
        ]
      : []),
  ];

  const customStyles = {
    headCells: {
      style: {
        backgroundColor: '#F2FFFB',
        fontWeight: '600',
        fontSize: '13px',
      },
    },
  };

  useEffect(() => {
    getDataPemateri();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, perPage, btnFilterSelected]);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      getDataPemateri();
    }, 500);

    return () => clearTimeout(delayDebounce);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [keyword]);

  const handlePerRowsChange = async (newPerPage, page) => {
    setPemateriState('page', page);
    setPemateriState('perPage', newPerPage);
  };

  const handlePageChange = (page) => {
    setPemateriState('page', page);
  };

  return (
    <>
      <ModalFormPemateri />
      <ModalDeletePemateri />
      <SidebarWithHeader title="Master Pemateri">
        <Box className="app">
          <Box as="main" p={0}>
            <Box className="container">
              <Box bg="white" p={5} borderRadius="lg" mb={5} shadow="lg">
                <Flex
                  justifyContent="space-between"
                  alignItems={{ md: 'stretch', lg: 'center' }}
                  flexDirection={{ md: 'column', lg: 'row' }}
                  mb={4}
                  gridGap={3}
                >
                  <Flex
                    wrap="wrap"
                    justifyContent={{ md: 'center', lg: 'flex-start' }}
                    gridGap="3"
                  >
                    <Button
                      colorScheme={
                        btnFilterSelected === null ? 'green' : 'gray'
                      }
                      onClick={() => {
                        setPemateriState('btnFilterSelected', null);
                      }}
                    >
                      Semua Data
                    </Button>
                    <Button
                      colorScheme={
                        btnFilterSelected === 'ASN' ? 'green' : 'gray'
                      }
                      onClick={() => {
                        setPemateriState('btnFilterSelected', 'ASN');
                      }}
                    >
                      ASN
                    </Button>
                    <Button
                      colorScheme={
                        btnFilterSelected === 'NON_ASN' ? 'green' : 'gray'
                      }
                      onClick={() => {
                        setPemateriState('btnFilterSelected', 'NON_ASN');
                      }}
                    >
                      NON-ASN
                    </Button>
                  </Flex>
                  <Flex
                    alignItems="center"
                    justifyContent={{ md: 'center', lg: 'flex-end' }}
                    mt={{ md: 3, lg: 0 }}
                    gap={3}
                  >
                    <InputGroup w="250px">
                      <InputLeftElement pointerEvents="none">
                        <FaSearch />
                      </InputLeftElement>
                      <Input
                        type="text"
                        placeholder="Cari Disini..."
                        onChange={(e) => {
                          setPemateriState('keyword', e.target.value);
                          setPemateriState('page', 1);
                        }}
                        _focus={{
                          ring: '1',
                          ringColor: 'green.700',
                          borderColor: 'green.700',
                        }}
                      />
                    </InputGroup>
                    {canMutate && (
                      <Button
                        colorScheme="green"
                        rightIcon={<Icon as={AiFillPlusCircle} />}
                        onClick={() => [
                          setPemateriState('isOpenModalPemateri', true),
                          setPemateriState('isEdit', false),
                        ]}
                        ml={2}
                      >
                        Tambah Baru
                      </Button>
                    )}
                  </Flex>
                </Flex>
                <DataTable
                  columns={columns}
                  data={listData}
                  progressPending={isLoading}
                  pagination
                  paginationServer
                  paginationTotalRows={totalPage > 0 ? totalPage : 0}
                  onChangeRowsPerPage={handlePerRowsChange}
                  onChangePage={handlePageChange}
                  customStyles={customStyles}
                  progressComponent={<Loader />}
                />
              </Box>
            </Box>
          </Box>
        </Box>
      </SidebarWithHeader>
    </>
  );
};

const PemateriMain: React.FC = () => {
  return (
    <PemateriContext.Provider>
      <Pemateri />
    </PemateriContext.Provider>
  );
};

export default PemateriMain;
